import React, { Suspense } from 'react';

import { SentryErrorBoundary, setupSentryClient } from '@atlassian/atlassian-studio-observability';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { AppSelector } from './AppSelector';
import { LoadingSpinner } from './common/ui/loading-spinner';
import { redirectToLogin } from './common/utils/redirect-utils';

setupSentryClient({
	packageName: '@atlassian/studio-foundations',
});

export const WrappedApp = (): React.JSX.Element => {
	return (
		<Suspense fallback={<LoadingSpinner size="large" />}>
			<AtlassianRelayEnvironmentProvider>
				{/* @NOTE: if any errors are thrown from inside the app selector: this is Relay related, 
				so we want to redirect to the login page, because this means that the user is not authenticated */}
				<SentryErrorBoundary fallbackComponent={() => null} onError={redirectToLogin}>
					<AppSelector />
				</SentryErrorBoundary>
			</AtlassianRelayEnvironmentProvider>
		</Suspense>
	);
};
